import React, { useState, useEffect } from 'react';

import * as Util from '../data/General';
import DashboardCards from '../components/widget/DashboardCards';

import * as Constants from '../store/index';
import Filter from '../components/widget/Filter';
import Card from '../components/widget/Card';
import Button from '../components/html/Button';
import ChartRequest from '../components/widget/ChartRequest';

import axios from "axios";
import { useStatistics } from '../hooks/useStatistics';

function ChatbotProm(props) {

  

  return (
    <div className='home'>
        
          <div className='cards-content-parent'>
              <div className='cards-content'>
                <Card 
                  img="img/ia/chatia-5.png"
                  title={Util.getMessage("chatbothelp8")}
                  subtitle={Util.getMessage("chatbothelp9")}
                  text={Util.getMessage("chatbothelp10")}
                />

                <Card 
                  img="img/ia/chatia-4.png"
                  title={Util.getMessage("chatbothelp11")}
                  subtitle={Util.getMessage("chatbothelp12")}
                  text={Util.getMessage("chatbothelp13")}
                />

                <Card 
                  img="img/ia/chatia-6.png"
                  title={Util.getMessage("chatbothelp14")}
                  subtitle={Util.getMessage("chatbothelp15")}
                  text={Util.getMessage("chatbothelp16")}
                />

                
            </div>
            <div className='cards-content'>
                <Card 
                  img="img/ia/chatia-3.png"
                  title={Util.getMessage("chatbothelp17")}
                  subtitle={Util.getMessage("chatbothelp18")}
                  text={Util.getMessage("chatbothelp19")}
                />

                <Card 
                  img="img/ia/chatia-2.png"
                  title={Util.getMessage("chatbothelp20")}
                  subtitle={Util.getMessage("chatbothelp21")}
                  text={Util.getMessage("chatbothelp22")}
                />

                <Card 
                  img="img/ia/chatia-1.png"
                  title={Util.getMessage("chatbothelp23")}
                  subtitle={Util.getMessage("chatbothelp24")}
                  text={Util.getMessage("chatbothelp25")}
                />
            </div>

            
              <div className='contect-chatbot-check'>
                  <img src="img/ia/lia.png" alt="Ilustración Lia" />
                  <div className='text-chatbox'>
                    <label className='title-chat' style={{marginBottom: "2rem"}}>{Util.getMessage("chatbothelp28")}</label>
                    <a href='https://calendly.com/renataraya/chatbot' className='btn-icon' target='_blank'>{Util.getMessage("chatbothelp29")}</a>
                  </div>
              </div>
          </div>

        
      <div>

      </div>
    </div>
  );
}

export default ChatbotProm;